import {
  Card,
  Checkbox,
  CrudMode,
  DataArray,
  DataDisplay,
  pn,
  Stack,
  Typography,
  ValidationErrors,
} from "@compass/core";
import { Select } from "components";
import { LkRole, LkUserPartnerAssignmentTypeId, User, UserEditResource } from "generated/openApi";
import produce from "immer";
import "moment-timezone";

export const MatchAssignment = (props: {
  crudMode: CrudMode;
  user: User;
  setUser: (value: User) => void;
  editResource: UserEditResource;
  validationErrors: ValidationErrors;
  selectedRole: LkRole | undefined;
}) => {
  const UNRESTRICTED: string = "Unrestricted (All)";

  return (
    <Card header="Match Assignment" fullHeight>
      <Stack spacing="md">
        <Stack>
          <Typography variant="caption">
            Match data can be configured for {props.selectedRole?.name} role to allow only access to specified Partners
            or Sub-Partners. Leave blank for unrestricted access to all data.
          </Typography>
        </Stack>

        <Stack>
          {props.crudMode === "view" && (
            <DataDisplay>
              {props.user.partnerAssignmentType?.id ? props.user.partnerAssignmentType?.name : UNRESTRICTED}
            </DataDisplay>
          )}

          {props.crudMode === "edit" && (
            <Select
              placeholder={UNRESTRICTED}
              value={props.editResource.userPartnerAssignmentTypes?.find(
                (x) => x.id === props.user.partnerAssignmentTypeId
              )}
              options={props.editResource.userPartnerAssignmentTypes}
              getOptionLabel={(option) => option.name}
              onChange={(e, value) =>
                props.setUser(
                  produce(props.user, (draft) => {
                    draft.partnerAssignmentTypeId = value?.id;
                  })
                )
              }
              errors={props.validationErrors[pn<User>("partnerAssignmentTypeId")]}
            />
          )}
        </Stack>

        <Stack>
          {props.user.partnerAssignmentTypeId === Number(LkUserPartnerAssignmentTypeId.Partner) && (
            <>
              {props.crudMode === "view" && <DataArray value={props.user.partners?.map((x) => x.name)} />}

              {props.crudMode === "edit" &&
                props.editResource.partners?.map((x) => (
                  <Stack>
                    <Checkbox
                      key={x.id}
                      checked={props.user.partners?.map((x) => x.id).includes(x.id)}
                      onClick={() =>
                        props.setUser(
                          produce(props.user, (draft) => {
                            const index: number | undefined = props.user.partners?.map((x) => x.id).indexOf(x.id);
                            if (index !== undefined && index >= 0) draft.partners?.splice(index, 1);
                            else draft.partners?.push(x);
                          })
                        )
                      }
                      label={x.name}
                    />
                  </Stack>
                ))}
            </>
          )}

          {props.user.partnerAssignmentTypeId === Number(LkUserPartnerAssignmentTypeId.SubPartner) && (
            <>
              {props.crudMode === "view" && <DataArray value={props.user.subPartners?.map((x) => x.name)} />}

              {props.crudMode === "edit" &&
                props.editResource.subPartners?.map((x) => (
                  <Stack>
                    <Checkbox
                      key={x.id}
                      checked={props.user.subPartners?.map((x) => x.id).includes(x.id)}
                      onClick={() =>
                        props.setUser(
                          produce(props.user, (draft) => {
                            const index: number | undefined = props.user.subPartners?.map((x) => x.id).indexOf(x.id);
                            if (index !== undefined && index >= 0) draft.subPartners?.splice(index, 1);
                            else draft.subPartners?.push(x);
                          })
                        )
                      }
                      label={`${x.partner?.name}: ${x.name}`}
                    />
                  </Stack>
                ))}
            </>
          )}
        </Stack>
      </Stack>
    </Card>
  );
};
